export const ACTIVE_TIMECLOCK_WORKING_HOURS_MESSAGE =
  "Un employé a une session de pointage toujours active. L'ajout d'heures risquerait de fusionner avec cette session en cours.";
export const ACTIVE_TIMECLOCK_WORKING_HOURS_CODE =
  "ACTIVE_TIMECLOCK_WORKING_HOURS";

export const ACTIVE_TIMECLOCK_CONFIRMATION_EVENT =
  "active-timeclock-working-hours-confirmation";
export const ACTIVE_TIMECLOCK_CONFIRMATION_CANCELLED =
  "ACTIVE_TIMECLOCK_CONFIRMATION_CANCELLED";

export const isActiveTimeclockWorkingHoursError = (error) => {
  const responseData = error?.response?.data || error;
  const message = responseData?.message || error?.message || "";
  const code = responseData?.data?.code || responseData?.code;

  console.log({ message, code });

  return (
    code === ACTIVE_TIMECLOCK_WORKING_HOURS_CODE ||
    message === ACTIVE_TIMECLOCK_WORKING_HOURS_MESSAGE
  );
};

export const requestActiveTimeclockConfirmation = (error) =>
  new Promise((resolve) => {
    window.dispatchEvent(
      new CustomEvent(ACTIVE_TIMECLOCK_CONFIRMATION_EVENT, {
        detail: {
          error,
          resolve
        }
      })
    );
  });

export const createActiveTimeclockConfirmationCancelledError = (error) =>
  Object.assign(new Error(ACTIVE_TIMECLOCK_CONFIRMATION_CANCELLED), {
    originalError: error,
    activeTimeclockConfirmationCancelled: true
  });

export const isActiveTimeclockConfirmationCancelled = (error) =>
  error?.activeTimeclockConfirmationCancelled ||
  error?.message === ACTIVE_TIMECLOCK_CONFIRMATION_CANCELLED;
